import _ from 'lodash';
import { createAction, handleActions } from 'redux-actions';

import { mappedModals } from '../components/modals';
import { USER_PERSONA_DISCOVERED } from '../store/actions';

export const UI_UPDATE = 'UI_UPDATE';
export const UI_TOGGLE_MODAL = 'UI_TOGGLE_MODAL';

// selectors
export const getModals = (state) => state.ux.modals;
export const getWindowWidth = (state) => state.ux.windowWidth;
export const getSnackbarMessage = (state) => state.ux.snackbar.snackbarMessage;
export const getSnackbarOpen = (state) => state.ux.snackbar.snackbarOpen;

// actions
export const updateUi = createAction(UI_UPDATE);
export const toggleModal = createAction(
  UI_TOGGLE_MODAL,
  (key, content, config) => ({
    key,
    content,
    config,
  })
);

// reducer
const initialState = {
  /**
   * @name _legacy_persona
   * @description Legacy form of persona still used in some views
   * @deprecated
   */
  _legacy_persona: null,

  persona: null, // taken from the token to normalize use between us and backend,

  fontSize: 12,
  windowWidth: window.innerWidth,
  modals: {
    modalConfig: {},
    modalContent: {},
    ...mappedModals,
  },
};

const UxReducer = handleActions(
  {
    [UI_UPDATE]: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    [USER_PERSONA_DISCOVERED]: (state, action) => {
      const { persona, _legacy_persona } = action.payload;

      return {
        ...state,
        persona,
        _legacy_persona,
      };
    },

    [UI_TOGGLE_MODAL]: (state, action) => {
      const activeModalKey = Object.keys(state.modals).find(
        (key) => _.isBoolean(state.modals[key]) && !!state.modals[key]
      );
      const updates = {};

      if (activeModalKey) {
        updates[activeModalKey] = false;
      }

      if (action.payload.key) {
        updates[action.payload.key] = true;
      }

      // user wants to close the current modal
      if (action.payload.key && action.payload.content === false) {
        updates[action.payload.key] = false;
      }

      return {
        ...state,
        modals: {
          ...state.modals,
          ...updates,
          modalContent:
            action.payload.content || initialState.modals.modalContent,
          modalConfig: action.payload.config || initialState.modals.modalConfig,
        },
      };
    },
  },
  initialState
);

export default UxReducer;
